module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assign role","title_edit":"Edit role assignment","role":"Role"},"da":{"title":"Tildel rolle","title_edit":"Rediger rolletildeling","role":"Rolle","timelimited":"Tidsbestemt tildeling?","timelimited_placeholder":"Vælg udløbsdato","timelimited_title":"Udløber den"}}')
  delete Component.options._Ctor
}
